// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * SB 574 Readiness questionnaire
 * Matches the featured-solution card on the homepage (Inter + Spectral, gold accent).
 */
.sb574-page {
  --sb-ink: #141727;
  --sb-text: #344767;
  --sb-muted: #67748e;
  --sb-red: #b42318;
  --sb-insert: #1849a9;
  --sb-gold: #ffbc00;
  --sb-gold-deep: #e89a00;
  --sb-hairline: #e9ecef;
  --sb-soft: #f8f9fa;

  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--sb-soft);
  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;
  color: var(--sb-text);
}

.sb574-main {
  flex: 1;
  padding: 3rem 1rem 4rem;
}

.sb574-container {
  max-width: 1120px;
  margin: 0 auto;
}

/* Intro */
.sb574-intro {
  max-width: 720px;
  margin-bottom: 2rem;
}

.sb574-eyebrow {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.625rem;
  margin-bottom: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--sb-muted);
}

.sb574-eyebrow-badge {
  padding: 0.25rem 0.6rem;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--sb-ink);
  border-radius: 0.375rem;
  background-image: linear-gradient(310deg, var(--sb-gold-deep) 0%, var(--sb-gold) 100%);
}

.sb574-title {
  margin: 0 0 1rem;
  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: -0.015em;
  color: var(--sb-ink);
}

.sb574-lede {
  font-size: 1.0625rem;
  line-height: 1.65;
}

/* Layout */
.sb574-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  align-items: start;
}

@media (min-width: 900px) {
  .sb574-layout {
    grid-template-columns: minmax(0, 1fr) 340px;
  }

  .sb574-score {
    position: sticky;
    top: 1.5rem;
  }
}

/* Questions */
.sb574-questions {
  list-style: none;
  margin: 0;
  padding: 0.5rem 1.5rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
}

.sb574-q {
  padding: 1.25rem 0;
  border-bottom: 1px solid var(--sb-hairline);
}

.sb574-q:last-child {
  border-bottom: 0;
}

.sb574-q-text {
  color: var(--sb-ink);
  font-size: 1rem;
  line-height: 1.55;
}

.sb574-q-num {
  font-weight: 600;
}

.sb574-q-meta {
  display: flex;
  gap: 0.625rem;
  align-items: baseline;
  margin-top: 0.375rem;
}

.sb574-code {
  font: 600 0.75rem ui-monospace, Menlo, monospace;
  color: var(--sb-ink);
}

.sb574-cite {
  font-size: 0.8125rem;
  color: var(--sb-muted);
}

.sb574-opts {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.625rem;
  margin-top: 0.75rem;
}

.sb574-opt {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.375rem 0.95rem;
  border: 1px solid #d2d6da;
  border-radius: 0.5rem;
  font-size: 0.9375rem;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.15s, background 0.15s;
}

.sb574-opt:hover {
  border-color: var(--sb-ink);
}

.sb574-opt.on {
  border-color: var(--sb-ink);
  background: var(--sb-ink);
  color: #fff;
}

.sb574-opt input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.sb574-opt:focus-within {
  outline: 2px solid var(--sb-gold);
  outline-offset: 2px;
}

.sb574-proof {
  font-size: 0.8125rem;
  color: var(--sb-muted);
}

/* Score */
.sb574-score-card,
.sb574-next {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
}

.sb574-next {
  margin-top: 1rem;
}

.sb574-progress {
  font-size: 0.8125rem;
  color: var(--sb-muted);
  margin-bottom: 0.75rem;
}

.sb574-score-empty {
  color: var(--sb-muted);
  margin-bottom: 1.25rem;
}

.sb574-big {
  font: 600 3rem/1 'Spectral', Georgia, serif;
  color: var(--sb-ink);
}

.sb574-big span {
  font-size: 1.5rem;
  color: #a0a7b4;
}

.sb574-band {
  margin: 0.5rem 0 0.25rem;
  font-family: 'Spectral', Georgia, serif;
  font-size: 1.375rem;
  font-weight: 600;
  color: var(--sb-ink);
}

.sb574-note {
  font-size: 0.875rem;
  color: var(--sb-muted);
}

.sb574-warn {
  display: flex;
  gap: 0.625rem;
  align-items: flex-start;
  margin-top: 1rem;
  padding: 0.75rem 0.875rem;
  background: #fdecea;
  border: 1px solid #f3c4bf;
  border-radius: 0.5rem;
  color: var(--sb-red);
  font-size: 0.875rem;
}

.sb574-warn svg {
  width: 18px;
  height: 18px;
  flex: none;
  margin-top: 2px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.sb574-btn {
  display: block;
  width: 100%;
  margin-top: 1.25rem;
  padding: 0.8rem 1rem;
  border-radius: 0.5rem;
  background: var(--sb-ink);
  color: #fff;
  font: 600 0.9375rem 'Inter', sans-serif;
}

.sb574-btn:hover:not(:disabled) {
  background: #000;
}

.sb574-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.sb574-fine {
  margin-top: 0.5rem;
  font-size: 0.8125rem;
  color: var(--sb-muted);
  text-align: center;
}

.sb574-link {
  display: block;
  margin: 0.75rem auto 0;
  background: none;
  color: var(--sb-muted);
  font-size: 0.8125rem;
  text-decoration: underline;
}

.sb574-next h3 {
  margin-bottom: 0.5rem;
  font-family: 'Spectral', Georgia, serif;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--sb-ink);
}

.sb574-next p {
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 0.75rem;
}

.sb574-next a {
  font-weight: 600;
  color: var(--sb-insert);
}

.sb574-disclaimer {
  margin-top: 2rem;
  font-size: 0.8125rem;
  color: var(--sb-muted);
}
`, "",{"version":3,"sources":["webpack://./src/pages/sb574/SB574ReadinessPage.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;;EAElB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,sEAAsE;EACtE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,sFAAsF;AACxF;;AAEA;EACE,gBAAgB;EAChB,0DAA0D;EAC1D,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,UAAU;AACV;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB","sourcesContent":["/*\n * SB 574 Readiness questionnaire\n * Matches the featured-solution card on the homepage (Inter + Spectral, gold accent).\n */\n.sb574-page {\n  --sb-ink: #141727;\n  --sb-text: #344767;\n  --sb-muted: #67748e;\n  --sb-red: #b42318;\n  --sb-insert: #1849a9;\n  --sb-gold: #ffbc00;\n  --sb-gold-deep: #e89a00;\n  --sb-hairline: #e9ecef;\n  --sb-soft: #f8f9fa;\n\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--sb-soft);\n  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;\n  color: var(--sb-text);\n}\n\n.sb574-main {\n  flex: 1;\n  padding: 3rem 1rem 4rem;\n}\n\n.sb574-container {\n  max-width: 1120px;\n  margin: 0 auto;\n}\n\n/* Intro */\n.sb574-intro {\n  max-width: 720px;\n  margin-bottom: 2rem;\n}\n\n.sb574-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.625rem;\n  margin-bottom: 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--sb-muted);\n}\n\n.sb574-eyebrow-badge {\n  padding: 0.25rem 0.6rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: var(--sb-ink);\n  border-radius: 0.375rem;\n  background-image: linear-gradient(310deg, var(--sb-gold-deep) 0%, var(--sb-gold) 100%);\n}\n\n.sb574-title {\n  margin: 0 0 1rem;\n  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;\n  font-size: clamp(2rem, 4vw, 2.75rem);\n  font-weight: 500;\n  line-height: 1.1;\n  letter-spacing: -0.015em;\n  color: var(--sb-ink);\n}\n\n.sb574-lede {\n  font-size: 1.0625rem;\n  line-height: 1.65;\n}\n\n/* Layout */\n.sb574-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n  align-items: start;\n}\n\n@media (min-width: 900px) {\n  .sb574-layout {\n    grid-template-columns: minmax(0, 1fr) 340px;\n  }\n\n  .sb574-score {\n    position: sticky;\n    top: 1.5rem;\n  }\n}\n\n/* Questions */\n.sb574-questions {\n  list-style: none;\n  margin: 0;\n  padding: 0.5rem 1.5rem;\n  background: #fff;\n  border-radius: 1rem;\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);\n}\n\n.sb574-q {\n  padding: 1.25rem 0;\n  border-bottom: 1px solid var(--sb-hairline);\n}\n\n.sb574-q:last-child {\n  border-bottom: 0;\n}\n\n.sb574-q-text {\n  color: var(--sb-ink);\n  font-size: 1rem;\n  line-height: 1.55;\n}\n\n.sb574-q-num {\n  font-weight: 600;\n}\n\n.sb574-q-meta {\n  display: flex;\n  gap: 0.625rem;\n  align-items: baseline;\n  margin-top: 0.375rem;\n}\n\n.sb574-code {\n  font: 600 0.75rem ui-monospace, Menlo, monospace;\n  color: var(--sb-ink);\n}\n\n.sb574-cite {\n  font-size: 0.8125rem;\n  color: var(--sb-muted);\n}\n\n.sb574-opts {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.625rem;\n  margin-top: 0.75rem;\n}\n\n.sb574-opt {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.375rem 0.95rem;\n  border: 1px solid #d2d6da;\n  border-radius: 0.5rem;\n  font-size: 0.9375rem;\n  cursor: pointer;\n  user-select: none;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.sb574-opt:hover {\n  border-color: var(--sb-ink);\n}\n\n.sb574-opt.on {\n  border-color: var(--sb-ink);\n  background: var(--sb-ink);\n  color: #fff;\n}\n\n.sb574-opt input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.sb574-opt:focus-within {\n  outline: 2px solid var(--sb-gold);\n  outline-offset: 2px;\n}\n\n.sb574-proof {\n  font-size: 0.8125rem;\n  color: var(--sb-muted);\n}\n\n/* Score */\n.sb574-score-card,\n.sb574-next {\n  background: #fff;\n  border-radius: 1rem;\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);\n  padding: 1.5rem;\n}\n\n.sb574-next {\n  margin-top: 1rem;\n}\n\n.sb574-progress {\n  font-size: 0.8125rem;\n  color: var(--sb-muted);\n  margin-bottom: 0.75rem;\n}\n\n.sb574-score-empty {\n  color: var(--sb-muted);\n  margin-bottom: 1.25rem;\n}\n\n.sb574-big {\n  font: 600 3rem/1 'Spectral', Georgia, serif;\n  color: var(--sb-ink);\n}\n\n.sb574-big span {\n  font-size: 1.5rem;\n  color: #a0a7b4;\n}\n\n.sb574-band {\n  margin: 0.5rem 0 0.25rem;\n  font-family: 'Spectral', Georgia, serif;\n  font-size: 1.375rem;\n  font-weight: 600;\n  color: var(--sb-ink);\n}\n\n.sb574-note {\n  font-size: 0.875rem;\n  color: var(--sb-muted);\n}\n\n.sb574-warn {\n  display: flex;\n  gap: 0.625rem;\n  align-items: flex-start;\n  margin-top: 1rem;\n  padding: 0.75rem 0.875rem;\n  background: #fdecea;\n  border: 1px solid #f3c4bf;\n  border-radius: 0.5rem;\n  color: var(--sb-red);\n  font-size: 0.875rem;\n}\n\n.sb574-warn svg {\n  width: 18px;\n  height: 18px;\n  flex: none;\n  margin-top: 2px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.sb574-btn {\n  display: block;\n  width: 100%;\n  margin-top: 1.25rem;\n  padding: 0.8rem 1rem;\n  border-radius: 0.5rem;\n  background: var(--sb-ink);\n  color: #fff;\n  font: 600 0.9375rem 'Inter', sans-serif;\n}\n\n.sb574-btn:hover:not(:disabled) {\n  background: #000;\n}\n\n.sb574-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.sb574-fine {\n  margin-top: 0.5rem;\n  font-size: 0.8125rem;\n  color: var(--sb-muted);\n  text-align: center;\n}\n\n.sb574-link {\n  display: block;\n  margin: 0.75rem auto 0;\n  background: none;\n  color: var(--sb-muted);\n  font-size: 0.8125rem;\n  text-decoration: underline;\n}\n\n.sb574-next h3 {\n  margin-bottom: 0.5rem;\n  font-family: 'Spectral', Georgia, serif;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--sb-ink);\n}\n\n.sb574-next p {\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin-bottom: 0.75rem;\n}\n\n.sb574-next a {\n  font-weight: 600;\n  color: var(--sb-insert);\n}\n\n.sb574-disclaimer {\n  margin-top: 2rem;\n  font-size: 0.8125rem;\n  color: var(--sb-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
